jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/accordion.js');

  loadMorePosts.init();
});


AOS.init();


// Load More Posts
var loadMorePosts = {
	init: function() {
    jQuery('#load-more').click(function(){
      loadMorePosts.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-posts-container');
		var postCount = jQuery('#load-posts-container .post-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {

				// Request for posts
				jQuery('#load-more').addClass('loading');
			},
			complete: function () {

				// Request for posts received / response is being sent back to us
				jQuery('#load-more').removeClass('loading');
			},
			success: function(data) {

				// We get posts back / successful response
				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-posts-container .post-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more').replaceWith('<a class="load-button" href="#blog-top">BACK TO TOP</a>');
				}

				return;
			}
		});
	}
}


// Category Filter
jQuery(document).ready(function($) {
  $('#category-select').change(function() {
    var selectedTag = $(this).val();

    $.ajax({
      type: 'POST',
      url: posts.ajaxurl,
      data: {
        action: 'filter_posts',
        category: selectedTag,
      },
      success: function(response) {
        $('#load-posts-container').html(response);

        if(selectedTag !== 'all') {
          $('.load-button').hide();

        } else {
          $('.load-button').show();
        }
      },
    });
  });
});


// Footer Animation
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

let direction = 1; // 1 for forward, -1 for reverse
let tween; // Define tween variable

function toggleDirection() {
  direction *= -1;
}

function updateTween() {
  const roadPath = document.querySelector("#road-path-1");

  if(tween) {
    tween.kill(); // Kill the existing tween
  }

  tween = gsap.to("#car-1", {
    ease: "power1.inOut",
    motionPath: {
      path: "#road-path-1",
      align: "#road-path-1",
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    duration: 10,
    paused: true,
    onComplete: () => {
      toggleDirection();
    }
  });
}

function updateTweenDuration() {
  const roadPath = document.querySelector("#road-path-1");
  const pathLength = roadPath.getBoundingClientRect().height;

  if(tween) {
    tween.duration(pathLength / 20); // Adjust multiplier as needed
  }
}

// Update tween and duration on window resize
function handleResize() {
  updateTween();
  updateTweenDuration();
}

// Initial setup
updateTween();
updateTweenDuration();

// Event listener for window resize
window.addEventListener("resize", handleResize);

ScrollTrigger.create({
  trigger: ".road-container",
  start: "top center",
  end: "bottom center",
  onEnter: () => {
    if (tween.progress() === 1) {
      tween.play();
    } else {
      tween.play();
    }
  },
  onLeaveBack: () => {
    toggleDirection();
    tween.reverse();
  }
});


// Function to calculate and apply padding top to Footer
function applyPaddingTop() {
  var roadContainer = document.querySelector('.road-container');
  var roadContainerHeight = roadContainer.offsetHeight;
  var paddingTopValue = roadContainerHeight * 0.6;

  document.querySelector('.footer-inner').style.paddingTop = paddingTopValue + 'px';
}

window.addEventListener('load', applyPaddingTop);
window.addEventListener('resize', applyPaddingTop);


// Footer Background Color
function applyBackgroundColorToFooter() {
  var mainElement = document.querySelector('main');

  if(mainElement) {
    var lastChild = mainElement.lastElementChild;
    var lastChildStyle = window.getComputedStyle(lastChild);
    var lastChildBgColor = lastChildStyle.backgroundColor;
    var footer = document.querySelector('footer');

    if(footer) {
      footer.style.backgroundColor = lastChildBgColor;
    }
  }
}

applyBackgroundColorToFooter();


// Two Columns Block
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections = document.querySelectorAll(".animation-section");

sections.forEach((section, index) => {
  const car = section.querySelector(".car-2");
  const roadPath = section.querySelector(".road-path-2");

  let tween = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween.invalidate();
  });
});


// Two Columns Block First
function addClassToFirstTwoColumns() {
  const element = document.querySelector('.two-columns');

  if(element) {
    element.classList.add('two-columns-first');
  }
}

document.addEventListener('DOMContentLoaded', addClassToFirstTwoColumns);

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections3 = document.querySelectorAll(".animation-section-3");

sections3.forEach((section, index) => {
  const car = section.querySelector(".car-3");
  const roadPath = section.querySelector(".road-path-3");

  let tween3 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween3.invalidate();
  });
});


// Two Columns Block First
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections4 = document.querySelectorAll(".animation-section");

sections4.forEach((section, index) => {
  const car = section.querySelector(".car-4");
  const roadPath = section.querySelector(".road-path-4");

  let tween4 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween4.invalidate();
  });
});


// Courses Block
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections5 = document.querySelectorAll(".animation-section");

sections5.forEach((section, index) => {
  const car = section.querySelector(".car-5");
  const roadPath = section.querySelector(".road-path-5");

  let tween5 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween5.invalidate();
  });
});


// Page Links
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections6 = document.querySelectorAll(".animation-section");

sections6.forEach((section, index) => {
  const car = section.querySelector(".car-6");
  const roadPath = section.querySelector(".road-path-6");

  let tween6 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween6.invalidate();
  });
});


// Page Links 7
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections7 = document.querySelectorAll(".animation-section-7");

sections7.forEach((section, index) => {
  const car = section.querySelector(".car-7");
  const roadPath = section.querySelector(".road-path-7");

  let tween7 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      start: 1,
      end: 0,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween7.invalidate();
  });
});


// Page Links 8
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const sections8 = document.querySelectorAll(".animation-section-8");

sections8.forEach((section, index) => {
  const car = section.querySelector(".car-3");
  const roadPath = section.querySelector(".road-path-3");

  let tween8 = gsap.to(car, {
    ease: "power1.inOut",
    motionPath: {
      path: roadPath,
      align: roadPath,
      start: 1,
      end: 0,
      autoRotate: true,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      scrub: true,
      invalidateOnRefresh: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

  ScrollTrigger.addEventListener("refreshInit", () => {
    tween8.invalidate();
  });
});


// Parallax Scroll
jQuery(function($) {
  $(document).ready(function() {
    var parallaxElement = $(".parallax-scroll"),
    parallaxQuantity = parallaxElement.length;

    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
        windowTop = $(window).scrollTop(),
        elementTop = currentElement.offset().top,
        elementHeight = currentElement.height(),
        viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
        scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.15 + "px, 0)"
        });
      }
    });

    $(window).on("scroll", function() {
      window.requestAnimationFrame(function() {
        for (var i = 0; i < parallaxQuantity; i++) {
          var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
          currentElement.css({
            transform: "translate3d(0," + scrolled * -0.15 + "px, 0)"
          });
        }
      });
    });
  });
});